import React from 'react'
import './CheckboxGroup.css'

const Checkbox = ({
  title,
  label1,
  value1,
  label2,
  value2,
  setSelectedValue,
  selectedValue,
  address = false,
  TC,
  studendtTC,
  style = {}
}) => {
  return (
    <div style={{ marginLeft: '0.5rem' }}>
      <div className='checkboxTitle' style={style}>
        {title}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: address ? 'column' : 'row',
          alignItems: address ? 'flex-start' : 'center',
          justifyContent: 'flex-start',
        }}
      >
        {!studendtTC ? (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
              onClick={() => !studendtTC && setSelectedValue(value1)}
            >
              <div className='checkboxBorder'>
                <div
                  className='checkboxIn'
                  style={{
                    backgroundColor:
                      selectedValue === value1 ? '#205c42' : '#fff',
                  }}
                ></div>
              </div>
              <div className='checkboxLabel'>{label1}</div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
              onClick={() => !studendtTC && setSelectedValue(value2)}
            >
              <div className='checkboxBorder'>
                <div
                  className='checkboxIn'
                  style={{
                    backgroundColor:
                      selectedValue === value2 ? '#205c42' : '#fff',
                  }}
                ></div>
              </div>
              <div className='checkboxLabel'>{label2}</div>
            </div>
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <div className='checkboxBorder'>
              <div
                className='checkboxIn'
                style={{
                  backgroundColor: '#205c42',
                }}
              ></div>
            </div>
            <div className='checkboxLabel'>{selectedValue}</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Checkbox
